module.exports = __webpack_public_path__ + "img/logo.7e16a835.png";